<template>
  <section class="content-task-register">
    <Breadcrumb :links="links" :data="{name: 'Tarefa', id: taskParams?.id}"/>
    <form class="content-task-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="content-input-default">
            <input type="text" name="name" v-model="task.name" value="" placeholder="Nome" required/>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="content-input-default-select" :class="{'content-input-default-select--active': selectedPlan && selectedPlan !== ''}">
            <select v-model="selectedPlan" disabled required>
              <option :value="plan.id">{{ plan.name }}</option>
            </select>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_35_1490" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12" style="mask-type: luminance;"><path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"></path></mask><g mask="url(#mask0_35_1490)"><path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"></path></g></svg>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <textarea placeholder="Descrição da tarefa" v-model="task.description" required></textarea>
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Tasks',
          routerName: 'Tasks'
        },
        {
          name: 'Nova Tarefa',
          routerName: 'RegisterTask'
        },
      ],
      selectedPlan: '',
      task: {
        id_user: '',
        id_plan: '',
        name: '',
        description: '',
      },
      taskParams: this.$route.params
    }
  },
  computed: {
    ...mapGetters({
      plans: 'Plans/plans',
      plan: 'Plans/plan',
      taskData: 'Tasks/task',
      user: 'User/user'
    }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions('Tasks', ['registerTask', 'consultTasks']),
    ...mapActions('Plans', ['consultPlans']),
    ...mapActions(['setImageFileUrl']),
    async handleSubmit(){
      let message = this.task?.id ? 'Tarefa editada com sucesso!' : 'Tarefa cadastrada com sucesso!';


      this.task.id_user = this.user.id;
      this.task.id_plan = this.selectedPlan;

      await this.registerTask(this.task);
      this.$router.push({ name: 'Tasks' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
  },
  async mounted() {
    this.selectedPlan = this.plan.id;
    console.log('TASK PARAMS', this.taskParams);
    if (this.taskParams?.idTask) {
      await this.consultTasks(this.taskParams);
      this.task = this.taskData;
      this.links[1].name = this.task.name;
    }
  }
}
</script>

<style lang="scss" scoped>
.content-task-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
